import React from 'react';
import { cn } from '@/lib/utils';

interface FormControlProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  error?: boolean;
}

export function FormControl({ children, error, className, ...props }: FormControlProps) {
  return (
    <div className={cn('relative inline-block w-full', className)} {...props}>
      {children}
    </div>
  );
}
interface FormHelperTextProps extends React.HTMLAttributes<HTMLParagraphElement> {
  error?: boolean;
}

export function FormHelperText({ children, error, className, ...props }: FormHelperTextProps) {
  return (
    <p className={cn('mt-2 text-sm', error ? 'text-red-500' : 'text-gray-500', className)} {...props}>
      {children}
    </p>
  );
}
